module.exports = __webpack_public_path__ + "static/media/chris-ocean-traits.64878f8b.png";